export default "__VITE_PUBLIC_ASSET__900129d1__"